import Img2 from './images2/img1.jpg'
import Img3 from './images2/img2.jpg'
import Img4 from './images2/img3.jpg'
import Img5 from './images2/img4.jpg'
import Img6 from './images2/img5.jpg'
import Img7 from './images2/img6.jpg'



const Data = [
 Img2,Img3,Img4,Img5,Img6,Img7

]
export default Data